const events = {
    LOGGED_IN: 'logged_in',
    LOGGING_IN: 'logging_in',
    FAILED_LOGIN: 'failed_login',
    LOGGED_OUT: 'logged_out',
    LOGGED_IN_AUTHORIZED: 'logged_in_authorized',
    HTTP_UNAUTHORIZED: 'http_unauthorized',
    LOGGING_DATA_LOADED: 'logging.data.loaded',
    LOGGING_DATA_UPDATED: 'logging.data.updated',
};

export default events;
